import { useCallback, useContext, useEffect } from 'react'
import _ from 'lodash'
import { useConceptStatus } from '../../../redux/selectConceptStatus2'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import L3Signature from '../l3/L3Signature'
import { useConceptValidator } from './useConceptValidator'
import { ConceptStatusValueType, ConceptValueDataType } from '@fusion-advantage/backcompat'
import { isConceptStatus } from '@fusion-advantage/formlib'
import L6FormContext from '../l6/L6FormContext'
import { useFormDispatch } from '../../../redux/formStoreHooks'
import { submitStatusUpdates } from '../../../redux/submitStatusUpdates'

interface L4SignatureProps {
	xpath?: string
	cid?: string
}

const L4Signature = ({ xpath, cid }: L4SignatureProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4Signature',
		cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.String],
	})
	const conceptStatus = useConceptStatus(cid)
	const dispatch = useFormDispatch()
	const handleSave = useCallback((svg: string) => {
		dispatch(submitStatusUpdates([{
			cid: cid!,
			value: svg,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}, [dispatch, cid])
	const handleDelete = useCallback(() => {
		dispatch(submitStatusUpdates([{
			cid: cid!,
			value: null,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}, [dispatch, cid])
	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isConceptStatus(conceptStatus)) {
		// probably passed SuperconceptStatus instead of ConceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4Signature ${cid}] conceptStatus is incorrect type`} />
	}
	const { setXpathValuedDeterminer } = useContext(L6FormContext)
	const shouldPrint = Boolean(conceptStatus?.value)
	useEffect(() => {
		if(xpath && shouldPrint) {
			setXpathValuedDeterminer(xpath, true)
			return () => {
				setXpathValuedDeterminer(xpath, false)
			}
		}
	}, [xpath, setXpathValuedDeterminer, shouldPrint])
	return (
		<L3Signature
			conceptStatus={conceptStatus}
			onSave={handleSave}
			onDelete={handleDelete}
		/>
	)
}

export default L4Signature
